module.exports = __webpack_public_path__ + "assets/img/lm_avatar_active.67f16719.png";